export const getImage = (src: string) => {
    const image = new Image();
    image.src = src;
    return image;
};

export const getImageSize = (image: HTMLImageElement) => {
    return new Promise((resolve, reject) => {
        image.onload = () => {
            resolve({ width: image.width, height: image.height });
        };
        image.onerror = (error) => {
            reject(error);
        };
    });
};
